import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField, InputAdornment, Tooltip } from '@material-ui/core';
import color from '../../assets/css/colors';
import { ReactComponent as Code } from '../../assets/icons/table.svg';
import { ReactComponent as Info } from '../../assets/icons/info.svg';
import Timer from '../Timer/Timer';

const useStyles = makeStyles(() => ({
  textFieldWrapper: {
    display: 'flex',
    position: 'relative',
  },
  tooltipWrapper: {
    position: 'absolute',
    top: 31,
    right: 1,
    padding: '9px 10px',
    backgroundColor: color.light.opacity,
    borderRadius: 5,
    '& svg': {
      width: 21,
      height: 21,
      cursor: 'help',
      '& path': {
        fill: color.primary.main,
      },
    },
  },
}));

const HtmlTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: color.light.main,
    maxWidth: 620,
    border: '1px solid ' + color.light.light,
    borderRadius: 10,
  },
}))(Tooltip);

const CodeField = (props) => {
  const classes = useStyles();

  const startIcon = () => {
    return (
      <InputAdornment position="start">
        <Code />
      </InputAdornment>
    );
  };

  const endIcon = () => {
    return (
      <Timer minutes={props.minutes || 2} seconds={0} setLoading={props.setLoading} />
    );
  };

  return (
    <div className={classes.textFieldWrapper}>
      <TextField
        style={{ marginTop: props.mt ? 20 : 0, marginBottom: props.mb ? props.mb : 0 }}
        fullWidth={true}
        autoFocus={props.autoFocus}
        autoComplete="off"
        error={props.error}
        required={props.required}
        disabled={props.disabled}
        id={props.id}
        name={props.name}
        label={props.label}
        placeholder={props.placeholder}
        helperText={props.error ? props.msg : props.helperText || ''}
        type="text"
        value={props.value || ''}
        onChange={props.onChange}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          startAdornment: startIcon(),
          endAdornment: props.startTimer ? endIcon() : null,
        }}
        inputProps={{
          readOnly: props.readOnly ? true : false,
          maxLength: props.max,
          autoComplete: 'off',
        }}
      />
      {(props.tooltip || props.htmlTooltip) && (
        <div className={classes.tooltipWrapper} style={{ marginTop: props.mt ? 20 : 0 }}>
          {props.tooltip ? (
            <Tooltip arrow placement="top" title={props.tooltip}>
              <Info />
            </Tooltip>
          ) : (
            <HtmlTooltip
              placement="right"
              title={<React.Fragment>{props.htmlTooltip}</React.Fragment>}
            >
              <Info />
            </HtmlTooltip>
          )}
        </div>
      )}
    </div>
  );
};
export default CodeField;
